import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { Modal, ModalBody } from "react-bootstrap";
import "../modal.css";
import InputField from "../../form/inputField/inputField";
import ErrorMsg from "../../form/errorMsg";
import { useDispatch } from "react-redux";
import {
  linkDistributor,
  linkDistributorList,
} from "../../../redux/actions/distributorActions";
import SelectCustomField from "../../form/selectField/selectCustomField";
import ChangeSaved from "../../popups/ChangeSaved";
import ErrorPopup from "../../popups/ErrorPopup";

const LinkDistributorModal = ({ show, handleClose, distributorListFunc }) => {
  const [distributorList, setDistributorList] = useState([]);
  const [onSuccessShow, onSetSuccessShow] = useState(false);
  const [onSuccessMsg, onSetSuccessMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");

  const phoneRegex = /^([+]\d{2})?\d{10}$/;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      linkDistributorList(onDistributorListSuccess, onDistributorListError),
    );
  }, []);
  const onDistributorListSuccess = (data) => {
    setDistributorList(data);
    console.log(data, "=");
  };

  const onDistributorListError = (err) => {
    console.log(err);
  };
  const initialValues = {
    mobile: "",
    distributor_id: "",
  };
  const validationSchema = Yup.object().shape({
    mobile: Yup.string()
      .trim()
      .matches(phoneRegex, "Not a valid Number")
      .required("Required"),
    distributor_id: Yup.string().required("Required"),
  });

  const onSubmit = (values) => {
    console.log(values);
    dispatch(linkDistributor(values, onSuccess, onError));
  };

  const timeOutFnc = () => {
    onSetSuccessShow(false);
    distributorListFunc();
  };

  const onSuccess = (data) => {
    console.log(data);
    handleClose();
    onSetSuccessShow(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    onSetSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      dialogClassName=""
      contentClassName="link-modal col-5 mx-auto p-2 fn_Nunito"
    >
      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize={true}
        >
          {({ setFieldValue, values }) => (
            <Form className="p-1">
              <p className="fn_Nunito fw_700 fs_18 my-2 px-0">
                Link to Distributor
              </p>

              <div className="basic-details-container align-items-center my-3">
                <span className="fs_14 color_747f9e">
                  <span className="text_red fw_500 me-1">Note :</span>
                  Distributor should be onboarded to link.
                </span>
              </div>

              <div className="my-2 mt-4">
                <InputField
                  id={"mobile"}
                  label={"Mobile Number"}
                  labelColor={"color_262c3d"}
                  type={"text"}
                  placeholder={"Enter mobile number"}
                  name={"mobile"}
                  maxLength={"10"}
                />
              </div>

              <div className="my-2 mb-4">
                <SelectCustomField
                  label={"Distributor ID"}
                  labelColor={"color_262c3d"}
                  placeholder={"Select distributor id"}
                  optionList={distributorList}
                  name={"distributor_id"}
                  id={"distributor_id"}
                  menuHeight="130px"
                  value={values.distributor_id}
                />
              </div>
              <div className="d-flex justify-content-end align-items-center gap-3">
                <button
                  type="button"
                  onClick={() => handleClose()}
                  className="modal-logout-btn fs_14 fw_700 px-4 py-2"
                  style={{ width: "130px" }}
                >
                  NO
                </button>
                <button
                  type="submit"
                  className="modal-cancel-btn fs_14 text-white py-2 px-4 fw_700"
                  style={{ width: "130px" }}
                >
                  LINK
                </button>
              </div>
            </Form>
          )}
        </Formik>
        <ChangeSaved show={onSuccessShow} title={onSuccessMsg} />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </ModalBody>
    </Modal>
  );
};

export default LinkDistributorModal;
